import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { ConsentBanner } from "@/components/site/ConsentBanner";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import Support from "@/pages/Support";
import Admin from "@/pages/Admin";

function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}

function App() {
  useLenis();
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App font-body">
      <div className="noise-overlay" aria-hidden="true" />
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/support" element={<Support />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms-of-use" element={<Legal doc="use" />} />
          </Routes>
          <ConsentBanner />
        </BrowserRouter>
      </LanguageProvider>
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
